import { type IstanzaSezioneDati } from '@framework/api-client/api/backoffice/schemas/istanzaSezioneDati.ts';
import { yup } from '@framework/validation/initYup.ts';
import { type YupAnyObjectSchema } from '@framework/validation/YupObjectSchema.ts';
import { useMemo } from 'react';
import { createDeclarationsSchema } from '../../declarations/createDeclarationsSchema.ts';

interface IParams {
  declarations: IstanzaSezioneDati[] | null | undefined;
}

/**
 * Hook che genera lo schema per la validazione delle dichiarazioni di un procedimento.
 * Necessario per la generazione degli initialValues.
 */
export function useProcedureSchema(params: IParams) {
  const { declarations } = params;

  const schema = useMemo(() => {
    if (!declarations)
      return yup.object().required().noUnknown() as YupAnyObjectSchema;

    const declarationSchema = createDeclarationsSchema(declarations, {
      readonly: true,
    });

    return declarationSchema;
  }, [declarations]);

  return schema;
}
